import moment from 'moment';

export const OTP_SIZE = 6;
export const SUPER_ADMIN = 'super_admin';
export const VERSION = '1.0';
export const COPYRIGHT_YEAR = moment().format('YYYY');